var render = function render(_c,_vm){return _c('div',{staticClass:"testimonials-block container py-y-gutter"},[_c('testimonials',{attrs:{"testimonials":_vm.props.testimonials}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }